//const MAPBOX_ID = "stenadmin/cju8cn8hm0saz1fl8cygzs9dc";
//const MAPBOX_ID = "stenadmin/ckkpc7ufx0bfm17qh51k6cs4b";
const MAPBOX_ID = "stenadmin/cly8bxq4h00gl01nw74tifck9"; // "Administrative Boundaries componentfor fixing + Hiding Western Sahara for Marocko"
const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1Ijoic3RlbmFkbWluIiwiYSI6ImNqdDhjaXBzNDA2czc0YW83NTVqM3FwbHoifQ.jGINtKBwz2AFKdQ3Bkafpg";
  
  
export const getMapboxUrl = () =>
  `https://api.mapbox.com/styles/v1/${MAPBOX_ID}/tiles/256/{z}/{x}/{y}?access_token=${MAPBOX_ACCESS_TOKEN}`;
